import SelectBox from "devextreme-react/select-box";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { select_all } from '../../api/dm_coso';
import { useAuth } from '../../contexts/auth';
import { pageBaseStatus } from '../../state/pageBaseStatus';
import { coSoActionTypes } from '../../state/reducers/coSoReducer';
export default ({ value, onValueChanged, cmb }) => {
  const { status, dm_cosos } = useSelector((x) => x.coSo);
  const { user, signOut } = useAuth();
  // const user_coso_ids = user?.campus.map(x=>x.dm_coso_id);
  const dispatch = useDispatch();
  useEffect(() => {
    if (status === pageBaseStatus.is_not_initial) {
      handleReload();
    }
  }, [status]);
  const handleReload = async () => {
    dispatch({ type: coSoActionTypes.LOAD.START })
    const res = await select_all();
    if (res.is_success) {
      dispatch({ type: coSoActionTypes.LOAD.SUCESS, payload: res.data })
    } else {
      dispatch({ type: coSoActionTypes.LOAD.ERROR, payload: res.message })
    }
  };
  return (
    <SelectBox
      dataSource={dm_cosos}
      displayExpr={"ten_co_so"}
      valueExpr={"id"}
      showClearButton={false}
      placeholder="Chọn cơ sở"
      stylingMode="outlined"
      ref={cmb}
      width="100%"
      onValueChanged={(e) => {
        if (e.event) onValueChanged(e.value || 1);
      }}
      value={value !== undefined ? value : ""}
    />
  );
};